import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  min-height: 100px;
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer02};

  ul {
    margin: 0;
    list-style-position: inside;
    padding: ${({ theme }): string => theme.spacers!.spacer01} 0;

    li {
      list-style: none;
      font-size: 14px;
      margin: 0 0 8px -4px;
    }

    li::before {
      content: '·';
      font-size: 25px;
      vertical-align: middle;
      line-height: 20px;
      margin-right: 10px;
    }

    li.error {
      color: ${({ theme }): string => theme.admanColors!.red.dark.fg[2]};
    }

    li.success {
      color: ${({ theme }): string => theme.admanColors!.green.light.fg[0]};
    }
  }
`;

export const StyledColumn = styled.div`
  min-width: 40%;
  margin-left: ${({ theme }): string => theme.spacers!.spacer02};
`;
